import initiationKit from './initiation'
import automationKit from './automation'
import drivingKit from './driving'
import { Kit } from '@sections/creabots/types/kits'
import aiKit from './ai'

export const Kits: { [key: string]: Kit } = {
  ['iniciacion']: initiationKit,
  ['automatizacion']: automationKit,
  ['conduccion']: drivingKit,
  ['inteligencia-artificial']: aiKit,
}